import React, { FC } from "react";

import { Stack } from "react-bootstrap";

import classNames from "classnames";
import { ReactSVG } from "react-svg";

import { useGetPresignedDownloadUrlMutation } from "@api/graphql";
import { DownloadIcon } from "@assets/icons";
import {
  DateFormat,
  convertDateUStoAU,
  documentInfoFromS3Location,
  documentKeyFromS3Location,
  formatStringToDateFormat,
} from "@util/index";

import styles from "./index.module.scss";

interface FileDisplayProps {
  s3_location: string;
  date_created?: Date | string;
}

export const FileDisplay: FC<FileDisplayProps> = ({ s3_location, date_created }) => {
  const [getPresignedDownloadUrl] = useGetPresignedDownloadUrlMutation();
  const fileInfo = documentInfoFromS3Location(s3_location);

  const dateToDisplay = date_created ? (
    formatStringToDateFormat(convertDateUStoAU(date_created), DateFormat.DD_MM_YY_SLASH)
  ) : (
    <></>
  );

  const GetUrl = async (key: string) => {
    try {
      const { data } = await getPresignedDownloadUrl({
        variables: { documentKey: key },
      });
      const downloadUrl = data?.getPresignedDownloadURL?.downloadUrl;
      if (!downloadUrl) {
        return;
      }
      window.open(downloadUrl, "_blank");
    } catch {
      return;
    }
  };

  return (
    <div className={classNames(styles["td-container"])}>
      <a
        href={""}
        onClick={(e) => {
          e.preventDefault();
          GetUrl(documentKeyFromS3Location(s3_location!));
        }}
        className={classNames(styles["download-anchor"])}
      >
        <Stack className={classNames(styles["report-type-csv"], "mb-1")} direction="horizontal" gap={2}>
          <ReactSVG className={styles["download-icon"]} src={DownloadIcon} />
          <span className={classNames(styles["file-name"], "b3 bold")}>{fileInfo.filename}</span>
        </Stack>
      </a>
      <i>{dateToDisplay}</i>
    </div>
  );
};
